<template>
    <div class="page-content">

        <!--    页面标题 start -->
        <div v-web-title :data-title="$t('message.chooseCoupon.title')"></div>
        <!--    页面标题 end -->

        <Coupon :is-choose-coupon="true" :room-type-prop="roomType"
                :handle-use-coupon="useCoupon"/>
        <div class="button-wrapper">
            <Button type="primary" class="button" @click="noCoupon">
                <span class="button-text">{{$t('message.chooseCoupon.noCouponButton')}}</span>
            </Button>
        </div>
    </div>
</template>

<script>
  import Coupon from "../../components/coupon/Coupon";
  import {goBack} from "../../common/common";
  export default {
    name: "ChooseCoupon",
    components: {Coupon},
    data() {
      return {
        // 房间类型
        roomType: 0,
      }
    },

    created() {

      // 前页传来的参数
      console.log('前页传来的参数 params: ', this.$route.query);
      this.roomType = this.$route.query.roomType;

    },

    methods: {

      // 不使用优惠券
      noCoupon() {
        localStorage.removeItem('coupon');
        goBack();
      },

      // 选中优惠券处理方法, 返回订房页
      useCoupon() {
        goBack();
      },

    }

  }
</script>

<style lang="scss" scoped>
    @import "@/assets/style/mainStyle.scss";
    @import "ChooseCoupon.scss";

</style>
